import { useMemo } from 'react';

import { useTerminalDefaults } from '../terminal/useTerminalDefaults';

const useCheckListDefaultFilters = () => {
  const terminalDefaults = useTerminalDefaults();
  return useMemo(() => ({
    status: ['Opened'],
    employeeId: terminalDefaults.employeeId !== undefined ? [terminalDefaults.employeeId] : ['all'],
    orderTypeId: ['all'],
    revenueCenterId: terminalDefaults.view === 'CheckList' ? [terminalDefaults.revenueCenterId as number] : ['all'],
    orderChannelId: ['all'],
    isLoading: terminalDefaults.loading,
  }), [terminalDefaults]);
};

export { useCheckListDefaultFilters };

